// Resolve a (possibly relative) href to an absolute URL suitable for clipboard
// copy, mailto, native share, or social-share intents. Mirrors the path-vs-
// absolute logic the deleted `ShareMenu` primitive used; lifted here so the
// share modal's Copy-link affordance and any future share-channel widget pull
// from a single source.

const ABSOLUTE = /^https?:\/\//i;

export function resolveShareUrl(href: string): string {
  if (ABSOLUTE.test(href)) return href;
  if (typeof window === 'undefined') return href;
  const path = href.startsWith('/') ? href : `/${href}`;
  return `${window.location.origin}${path}`;
}
